// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SharedScreen__container-c69309 {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--addition-50);
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  width: 100%;
  height: 100%;
  background-color: var(--addition-100);
  border-radius: 8px;
  flex-direction: column;
}

.SharedScreen__icon-d1ec9a {
  margin-bottom: 6px;
  fill: currentColor;
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/SharedComponents/SharedScreen/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,0CAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--addition-50);\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  width: 100%;\n  height: 100%;\n  background-color: var(--addition-100);\n  border-radius: 8px;\n  flex-direction: column;\n}\n\n.icon {\n  margin-bottom: 6px;\n  fill: currentColor;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SharedScreen__container-c69309`,
	"icon": `SharedScreen__icon-d1ec9a`
};
module.exports = ___CSS_LOADER_EXPORT___;
